export default {
  "base": "py-3 px-4 font-semibold text-sm text-left border-e border-b first:border-s border-t border-(--ui-border-muted)"
}